import * as ko from "knockout";
import * as _ from "underscore";
import { Api } from "../app-api";
import { App } from "../app";
import { Cart } from "../app-cart";
import { Gtm } from "../app-gtm";
import { CreditCard, PromoCode } from "./models/checkout-models";

const divRoot: HTMLDivElement = document.querySelector("#ko-checkout");
const divModel: HTMLDivElement = document.querySelector("#divRegisterCheckoutModel");

export class ViewModel {
    hasCustomerCreditCard: boolean = false;
    noBalance: boolean;
    total: string;

    busy = ko.observable(false);
    cart = ko.observable<Cart>();
    promoCode = ko.observable<PromoCode>();

    policy = ko.observable(false);
    waiver = ko.observable(false);

    useToken = ko.observable(false);
    creditCard = ko.observable<CreditCard>();
    customerCreditCard = ko.observable<any>();

    showPolicy: () => void;
    showWaiver: () => void;

    next: () => void;
    tokenPay: () => void;

    constructor(model: any) {
        let self = this;

        const data = JSON.parse(model);

        self.cart(new Cart(data.cart, data.returnUrl));

        self.promoCode(new PromoCode(data.cart.promoCode, self.busy));
        
        self.noBalance = self.cart().payment.noBalance;
        self.total = self.cart().payment.total;

        if (!self.noBalance) {
            self.creditCard(new CreditCard());
            self.customerCreditCard(data.customerCreditCard);
            self.hasCustomerCreditCard = self.customerCreditCard() !== null;
        }

        self.busy.subscribe(newVal => App.busy(newVal));

        self.showPolicy = () => {
            Api.GetCancellationPolicyInfo()
                .done(results => {
                    App.showInfo(results, "Cancellation Policy");
                });
        }

        self.showWaiver = () => {
            Api.GetWaiverInfo()
                .done(results => {
                    App.showInfo(results, "Waiver");
                });
        }

        self.next = () => {
            if (!self.busy())
                self.checkout();
        }

        self.tokenPay = () => {
            if (!self.busy()) {
                self.useToken(true);
                self.checkout();
            }
        }

        Gtm.checkout();
    }

    private toJson() {
        let self = this;

        return {
            policy: self.policy(),
            waiver: self.waiver(),
            useToken: self.useToken(),
            noBalance: self.noBalance,
            card: self.noBalance ? null : self.creditCard().json()
        }
    }

    private checkout() {
        let self = this;

        App.scrollTop(500); //show busy

        self.busy(true);

        const data = self.toJson();

        //console.log(JSON.stringify(data));
        //return;

        Api.Checkout(data)
            .done(results => {
                if (results.error) { return App.alertError(results.message); }
                if (!App.isValid(results.valid)) { return App.alertWarning(results.message); }
                Gtm.purchase(self.cart(), results.purchase);
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }
}

function init() {
    if (divModel) {
        ko.applyBindings(new ViewModel(divModel.textContent), divRoot);
    }
}

$(document).ready(() => init());